import { motion } from "framer-motion";
import { Fade as Hamburger } from "hamburger-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { getMenuItemStyle } from "../../Constants/Constants";
import { navbarMotionSettings } from "../../Constants/FramerMotions";
import "./navbar.scss";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("home");

  // for smooth scrolling to that component
  const handleSelectMenuItem = (componentName) => {
    setMenuOpen(false);
    const section = document?.querySelector(`#${componentName}`);

    // taking navbar height into consideration
    if (section) {
      const navbarHeight =
        document.querySelector(".navbar-wrapper").clientHeight;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionTop - navbarHeight,
        behavior: "smooth",
      });
    }
  };

  // Function to handle scroll and update the active link
  const handleScroll = () => {
    const scrollPosition = window.scrollY || window.pageYOffset;

    // Define the scroll thresholds for each section or element
    const homeSection = document.getElementById("Hero");
    const aboutSection = document.getElementById("About");
    const projectsSection = document.getElementById("Projects");
    const skillsSection = document.getElementById("Skills");
    const contactSection = document.getElementById("Contact");

    // Calculate the top offset of each section or element
    const homeOffset = homeSection.offsetTop - 100;
    const aboutOffset = aboutSection.offsetTop - 100;
    const projectsOffset = projectsSection.offsetTop - 100;
    const skillsOffset = skillsSection.offsetTop - 100;
    const contactOffset = contactSection.offsetTop - 100;

    // Determine the active link based on the scroll position
    if (scrollPosition >= homeOffset && scrollPosition < aboutOffset) {
      setActiveLink("hero");
    } else if (
      scrollPosition >= aboutOffset &&
      scrollPosition < projectsOffset
    ) {
      setActiveLink("about");
    } else if (
      scrollPosition >= projectsOffset &&
      scrollPosition < skillsOffset
    ) {
      setActiveLink("projects");
    } else if (
      scrollPosition >= skillsOffset &&
      scrollPosition < contactOffset
    ) {
      setActiveLink("skills");
    } else if (scrollPosition >= contactOffset) {
      setActiveLink("contact");
    }
  };

  // Attach scroll event listener when the component mounts
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // for checking if navbar link is === to visible component (depends on above useEffect)
  const checkActiveLink = (componentName) => {
    if (activeLink === componentName) {
      return "active-link";
    } else {
      return "";
    }
  };

  return (
    <div className="navbar-wrapper">
      <span className="infinite-animate"></span>

      <motion.div
        className="container"
        variants={navbarMotionSettings}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        {/* puneet sharma name (logo) section */}
        <div className="logo-sec">
          <Link to="/" style={{ color: "black" }}>
            <div
              onClick={() => {
                window.scrollTo(0, 0);
              }}
              className="logo-name"
            >
              {"< Puneet Sharma />"}
            </div>
          </Link>
        </div>

        {/* menu items section */}
        <ul className="menu-items" style={getMenuItemStyle(menuOpen)}>
          <div spy="true" smooth="true" to="Hero" delay={0} duration={0}>
            <li
              className={checkActiveLink("hero")}
              onClick={() => handleSelectMenuItem("Hero")}
            >
              .home()
            </li>
          </div>

          <div spy="true" smooth="true" to="About" delay={0} duration={0}>
            <li
              className={checkActiveLink("about")}
              onClick={() => handleSelectMenuItem("About")}
            >
              .about()
            </li>
          </div>

          <div spy="true" smooth="true" to="Projects" delay={0} duration={0}>
            <li
              className={checkActiveLink("projects")}
              onClick={() => handleSelectMenuItem("Projects")}
            >
              .projects()
            </li>
          </div>

          <div spy="true" smooth="true" to="Skills" delay={0} duration={0}>
            <li
              className={checkActiveLink("skills")}
              onClick={() => handleSelectMenuItem("Skills")}
            >
              .skills()
            </li>
          </div>
          <div spy="true" smooth="true" to="Contact" delay={0} duration={0}>
            <li
              className="contact-li-btn"
              onClick={() => handleSelectMenuItem("Contact")}
            >
              Contact
            </li>
          </div>
        </ul>

        {/* menu items for mobile screens */}
        <Hamburger
          className="menu-icon"
          toggled={menuOpen}
          toggle={() => setMenuOpen((prev) => !prev)}
          size={29}
          duration={0.3}
          rounded
        />
      </motion.div>
    </div>
  );
};

export default Navbar;
